/**
 * Created by osirvent on 25/01/2016.
 */
angular.module('annexaApp')
    .controller('SendMailController',['$scope','$uibModalInstance', '$translate', 'doc', 'EmailFactory','DccumentsFactory',  function($scope, $uibModalInstance, $translate, doc, EmailFactory, DccumentsFactory) {
        $scope.doc = doc;
        DccumentsFactory.getAttachments($scope.doc.idDoc).then(function(data) {
            $scope.doc.docnameattachments.length = 0;
            if(data){
                _.forEach(data, function(attach){
                    $scope.doc.docnameattachments.push(attach);
                });
            }
        }).catch(function(error) {
        });
        $scope.alerts = [];
        $scope.emailFields = [
            {
                key: 'to',
                type: 'annexaInput',
                templateOptions: {
                    type: 'email',
                    label: $translate.instant('global.email.to') + $translate.instant('global.email.multiple'),
                    required: true
                },
	            validators:{
	                "email": {
	                    "expression": function (viewValue, modelValue, scope) {
	                        var valid = true;
	                        if(modelValue) {
		                        var expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	                        	var emails = modelValue.replaceAll(/\s+/g, '').split(";");
	                        	_.forEach(emails, function(email){
			                        if (!expr.test(email) ){
			                        	valid = false;
			                        }
	                            });
	                        } else {
	                        	valid = false;
	                        }
	                        return valid;
	                    }
	                }
	            }
            },
            {
                key: 'cc',
                type: 'annexaInput',
                templateOptions: {
                    type: 'email',
                    label: $translate.instant('global.email.cc') + $translate.instant('global.email.multiple')
                },
	            validators:{
	                "email": {
	                    "expression": function (viewValue, modelValue, scope) {
	                        var valid = true;
	                        if(modelValue) {
		                        var expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	                        	var emails = modelValue.replaceAll(/\s+/g, '').split(";");
	                        	_.forEach(emails, function(email){
			                        if (!expr.test(email) ){
			                        	valid = false;
			                        }
	                            });
	                        }
	                        return valid;
	                    }
	                }
	            }
            },
            {
                key: 'cco',
                type: 'annexaInput',
                templateOptions: {
                    type: 'email',
                    label: $translate.instant('global.email.cco') + $translate.instant('global.email.multiple')
                },
	            validators:{
	                "email": {
	                    "expression": function (viewValue, modelValue, scope) {
	                        var valid = true;
	                        if(modelValue) {
		                        var expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	                        	var emails = modelValue.replaceAll(/\s+/g, '').split(";");
	                        	_.forEach(emails, function(email){
			                        if (!expr.test(email) ){
			                        	valid = false;
			                        }
	                            });
	                        }
	                        return valid;
	                    }
	                }
	            }
            },
            {
                key: 'subject',
                type: 'annexaInput',
                templateOptions: {
                    type: 'text',
                    label: $translate.instant('global.literals.subject'),
                    translate: 'global.subject',
                    required: true
                }
            },
            {
                key: 'text',
                type: 'annexaTextArea',
                templateOptions: {
                    label: 'Text',
                    translate: $translate.instant('global.literals.text'),
                    rows: 5,
                    required: true
                }
            },
            {
                key: 'docName',
                type: 'annexaLabelRow',
                templateOptions: {
                    label: $translate.instant('global.email.attachment'),
                    value:doc.docname
                },
                data: {
                    informed:true,
                    row:true,
                    breakLine: true,
                    colClass: ' col-sm-12',
                    labelClass: 'label-strong'
                }
            },
            {
                key: 'documents',
                type: 'annexaRadioCheckboxRow',
                className: 'col-sm-12 daughter-label-strong',
                data: {
                    informed: true,
                    row: true
                },
                templateOptions: {
                    type: 'checkHTMLOneModelMail',
                    optionsAttr: 'bs-options',
                    required: false,
                    validate: true,
                    options: doc.docnameattachments,
                    ngOptions:'option[to.valueProp] as option in to.options',
                    valueProp: 'id',
                    labelProp: 'fileName'
                }
            },
            {
                key: 'dossierTransaction',
                type: 'annexaSelectRow',
                className: 'col-xs-12',
                templateOptions: {
                    optionsAttr: 'bs-options',
                    ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                    label: 'global.literals.transaction',
                    valueProp: 'id',
                    labelProp: '',
                    placeholder: '',
                    options: [],
                    required: true,
                },
                controller:['$scope', 'Language', 'apiAdmin', function($scope, Language, apiAdmin) {
                	_.forEach(doc.dossierTransactions, function(dossierTransaction){
                		dossierTransaction.label = dossierTransaction.dossier.dossierNumber +' '+ dossierTransaction[Language.getActiveColumn()];
                	});
                	$scope.to.labelProp = 'label';
                    $scope.options.templateOptions.options = doc.dossierTransactions;
                }],
                data: {
                    row: true,
                    informed: true
                },
                hideExpression: function($viewValue, $modelValue, scope) {
                    if(doc.dossierTransactions && doc.dossierTransactions.length > 0 ) {
                        return false;
                    } else {
                        return true;
                    }
                }
            }
        ];

        $scope.email = {
            to: '',
            cc: '',
            cco: '',
            subject: '',
            text: ''
        }


        $scope.ok = function() {
            if(this.emailForm.$valid) {
                var loading = this;
                var multiple = false;
                var multipleCC = false;
                var multipleCCO = false;
                var emails = undefined;
                var emailsCC = undefined;
                var emailsCCO = undefined;
                loading.$parent.showLoadingdivSignin = true;
                var attachments = [];
                if(this.email.documents){
                   attachments = $linq(Object.keys(this.email.documents)).where(function(x){
                        if(loading.email.documents[x]){
                            return true;
                        }else{
                            return false;
                        }
                    }).toArray();
                }
                if(this.email.to) {
                	var expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                	if(this.email.to.replaceAll(/\s+/g, '').split(";").length > 1){
                		emails = this.email.to.replace(/\s+/g, '').split(";");
                		multiple = true;
                	}
                }
                if(this.email.cc) {
                	var expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                	if(this.email.cc.replaceAll(/\s+/g, '').split(";").length > 1){
                		emailsCC = this.email.cc.replace(/\s+/g, '').split(";");
                		multipleCC = true;
                	}
                }
                if(this.email.cco) {
                	var expr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                	if(this.email.cco.replaceAll(/\s+/g, '').split(";").length > 1){
                		emailsCCO = this.email.cco.replace(/\s+/g, '').split(";");
                		multipleCCO = true;
                	}
                }
                if(this.email.dossierTransaction){
                	var transaction = $linq(this.doc.dossierTransactions).where("x => x.id =="+this.email.dossierTransaction).toArray();
                	this.doc.dossier = transaction[0].dossier.id;
                	this.doc.transaction = transaction[0].id;
                }
                EmailFactory.sendEmail(this.email, this.doc, attachments, emails, multiple, emailsCC, multipleCC, emailsCCO, multipleCCO)
                    .then(function(data) {
                        loading.$parent.showLoadingdivSignin = false;
                        $uibModalInstance.close();
                    }, function (error) {
                        if(error && error.data && error.data.message == 'Mail max size exceded not found') {
                            $scope.alerts.push({ msg: 'global.errors.errorSendMailMaxSize'});
                        }else{
                            $scope.alerts.push({msg: 'global.errors.errorSendMail'});
                        }
                        loading.$parent.showLoadingdivSignin = false;
                    }).catch(function(error) {
                    if(error && error.data && error.data.message == 'Mail max size exceded not found'){
                        $scope.alerts.push({ msg: 'global.errors.errorSendMailMaxSize'});
                    }else{
                        $scope.alerts.push({ msg: 'global.errors.errorSendMail'});
                    }
                    loading.$parent.showLoadingdivSignin = false;
                });

            }
        };

        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.closeAlert = function(index){
            $scope.alerts.splice(index,1);
        }
    }]);

angular.module('annexaApp')
    .directive('sendmail',['$uibModal', function ($uibModal) {
        return {
            transclude: true,
            restrict: 'EA',
            template: '<a href="" class="{{linkclass}}" ng-click="open()" ng-transclude>{{name}}</a>',
            scope: {
                linkclass: '@',
                docid: "@",
                idUser: "@",
                idDoc: "@",
                dossier: "@?",
                transaction: "@?",
                dossiertransaction: "@?"
            },
            link: function(scope, element, attrs) {
                scope.linkclass = attrs.linkClass;
                scope.open = function() {
                    var uimodalInstance = $uibModal.open({
                        templateUrl: './scripts/directives/sendmail/sendmail.html',
                        controller: 'SendMailController',
                        size: 'md',
                        windowClass: 'black-overlay',
                        backdrop: 'static',
                        resolve: {
                            doc: function() {
                                return {
                                    docid: attrs.docId,
                                    docname: attrs.docName,
                                    idUser: attrs.idUser,
                                    idDoc: attrs.idDoc,
                                    docnameattachments:[],
                                	dossier: attrs.dossier,
                                	transaction: attrs.transaction,
                                	dossierTransactions: angular.fromJson(attrs.dossiertransactions)
                                };
                            }
                        }
                    });

                    uimodalInstance.result.then(function() {
                        console.log('Finished');
                    }, function() {
                       console.log('Modal dismissed at: ' + new Date());
                    });
                };
            }
        };
    }]);

